module.exports = __webpack_public_path__ + "static/media/SKINCARE_PRO.6dd95b71.png";